<template>
  <!-- 
        资源分类tree
    -->
  <div class="material-aside" :style="{'height': height }">
    <div class="material_tree" v-for="(item, index) in leftTree" :key="index">
      <div
        class="material_chapters"
        :class="isClickAll ? 'click_color' : ''"
        @click="clickTitleSearch(catalogTreeId)"
      >
        <span v-show="!isClickAll" >{{ subjectname }}</span >
        <span v-show="isClickAll" >{{ subjectname }}</span >
      </div>
      <div class="material_CTreeCtrl">
        <el-tree
          :data="item.materials"
          node-key="id"
          default-expand-all
          ref="tree"
          :props="defaultProps"
          :expand-on-click-node="false"
          @node-click="(data) => treeClick(data)"
          empty-text="暂无目录"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
              v-if="data.status == 1"
              class="father"
              :title="`${node.label}`"
              >{{ node.label }}</span
            >
            <!-- <span v-if="data.status == 1" class="questionAmount"
              >（{{ data.questionAmount }}）</span
            > -->
            <el-input
              class="nodeInput"
              v-if="data.status == 0"
              style="width: 90%; margin-right: 20px"
              v-model="data.name"
              size="small"
              :ref="'edit' + data.id"
              @blur="blurEdit(data, node)"
              @keyup.enter.native="$event.target.blur"
            ></el-input>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/questionApi";
export default {
  name: "catalog-tree",
  components: {},
  props: {
    subjectId: {
      type: [Number, String],
      default: "",
    },
    height: {
      // 表格高度
      type: [String],
      default: "100%",
    },
  },
  data() {
    return {
      subjectname: null,
      //左侧目录树
      leftTree: [],
      defaultProps: {
        label: "name",
      },
      catalogTreeId: null,
      isClickAll: true,
      totalCount: 0,
      subjectIdNew: '',
      courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
    };
  },
  watch: {
    subjectId(val) {
      this.subjectIdNew = val
    }
  },
  created() {
    // if (this.courseModel == 2) {
    //   // this.getSubjects();
    //   this.treeList()
    // }
  },
  mounted() {
    this.subjectIdNew = this.subjectId;
    // if (this.courseModel != 2) {
    //   this.treeList()
    // }
    this.treeList();
  },

  methods: {
    //左侧目录树方法
    treeList() {
      api
        .FindMaterials(this.subjectIdNew)
        .then((res) => {
          if (res.code == "0") {
            this.subjectname = res.data.name;
            this.leftTree = [];
            this.isClickAll = true;
            this.leftTree.push(res.data);
            this.catalogTreeId = res.data.id;
            this.totalCount = res.data.allQuestionNumber;
          } else {
            this.$message.error(res.msg);
          }
          this.$emit("treeClick", [], this.subjectIdNew); // materialid、subjectid
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击搜索
    treeClick(data) {
      this.isClickAll = false;
      let ids = [];
      ids.push(data.id);
      this.$emit("treeClick", ids, this.subjectIdNew);
    },
    // 点击标题搜索
    clickTitleSearch(n) {
      this.isClickAll = true;
      if (n == "") return;
      this.$emit("treeClick", [], this.subjectIdNew);
      // this.treeList(n);
    },
  },
};
</script>

<style scoped lang="scss">
.material-aside {
  // overflow: auto;
}
.material_chapters {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0F0D11;
  line-height: 22px;
  height: 22px;
  cursor: pointer;
  margin-bottom: 5px;
  // &:hover {
  //   background: #F5F5F7;
  // }
}
/deep/ .el-collapse-item__header {
  width: 93%;
  height: 34px;
  border-radius: 4px 4px 4px 4px;
  position: relative;
  margin-bottom: 8px;
  /*border-left: 2px solid rgba(83,151,247,1);*/
  font-size: 14px;
  padding-left: 12px;
  line-height: 34px;
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(83, 151, 247, 1);
    font-weight: bold;
  }
}
/deep/ .el-icon-arrow-right:before {
  color: rgba(83, 151, 247, 1);
}
/deep/ .el-collapse {
  border-top: none;
  border-bottom: none;
}
/deep/ .material_tree {
  height: 100%;
  .material_chapt {
    padding-bottom: 4px;
  }
  .material_CTreeCtrl {
    height: calc(100% - 28px);
    overflow: auto;
  }
  .el-tree-node__content {
    height: 32px;
    position: relative;
    .course_catalog_operation {
      display: none;
      i {
        margin-left: 3px;
        color: #5397f7;
      }
    }
  }
  .el-tree-node > .el-tree-node__children {
    overflow: inherit;
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #fff;
    border-radius: 2px;
    color: #1890FF;
    /*border-left: 2px solid #5397F7;*/
    .father,
    .questionAmount {
      color: #1890FF;
    }
  }
  .el-tree-node__content:hover {
    height: 32px;
    border-radius: 2px;
    background: #F5F5F7;
    .father,
    .questionAmount {
      color: #333333;
    }
  }
  .el-collapse-item__content {
    padding-bottom: 0px;
  }
}
// /deep/ .el-tree-node__content > .el-tree-node__expand-icon {
//     /*color:rgba(83,151,247,1);*/
// }
/deep/ .tree-icon {
  color: rgba(83, 151, 247, 1);
}
/deep/ .el-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}

/deep/ .custom-tree-node {
  width: 100%;
}
.father {
  float: left;
  // max-width: 150px;
  max-width: 66%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #9498a3;
}
.questionAmount {
  float: left;
  font-size: 12px;
  color: #9498a3;
}
.child {
  float: right;
  padding-right: 5%;
  display: none;
}
.custom-tree-node .child {
  display: none;
}

.custom-tree-node:hover .child {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/catalog-tree.vue